var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "face" }, [
    _vm.isSuccessful == 1
      ? _c("div", { staticClass: "face-box" }, [
          _c("div", { staticClass: "face-box_title" }, [
            _c("b", [_vm._v("人脸识别")]),
            _c("p", [_vm._v("请衣着整齐，平视摄像头，并正对光源")]),
            _c("div", [_c("span", [_vm._v(_vm._s(_vm.msgData))])]),
          ]),
          _vm._m(0),
          _c("canvas", {
            staticStyle: { display: "none" },
            attrs: { id: "canvas", width: "300", height: "300" },
          }),
          _vm.msgData != "现在进行人脸识别..."
            ? _c(
                "div",
                { staticClass: "faceDivSuccessful" },
                [
                  _c("br"),
                  _c("p", [_vm._v("请拨打下方电话，联系管理员")]),
                  _c(
                    "el-button",
                    {
                      staticClass: "refer-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.setSuccessful },
                    },
                    [_vm._v("重新识别")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.isSuccessful === 2
      ? _c(
          "div",
          { staticClass: "faceDivSuccessful" },
          [
            _c("img", {
              attrs: {
                src: require("../assets/images/faceSuccessful.png"),
                alt: "",
              },
            }),
            _c(
              "p",
              [
                _vm._v(" 已识别成功"),
                _c("br"),
                _vm._v("点击下方按钮 "),
                _vm.isTest ? [_vm._v("去开始考试")] : _vm._e(),
              ],
              2
            ),
            _c(
              "el-button",
              {
                staticClass: "refer-btn",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.isRouter()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.isTest ? "开始考试" : "下一步") + " ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "face-box_content",
        staticStyle: { width: "280px", height: "280px" },
      },
      [
        _c("span", { staticClass: "b1" }),
        _c("span", { staticClass: "b2" }),
        _c("span", { staticClass: "b3" }),
        _c("span", { staticClass: "b4" }),
        _c("em"),
        _c("video", {
          staticStyle: {
            "object-fit": "fill",
            width: "280px",
            height: "280px",
          },
          attrs: {
            id: "video",
            playsinline: "",
            autoplay: "",
            "x5-video-player-type": "h5",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }